import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { CurrencyDisplayProps, CurrencyDisplay } from '@/components/localization';
import { Trans } from '@lingui/react/macro';
import {
    getMaximumFractionDigits,
    getMinimumProjectFractionDigits,
} from '@/components/localization/CurrencyDisplay';

const ProjectCurrencyDisplay: React.FC<Omit<CurrencyDisplayProps, 'currency'>> = ({
    minimumFractionDigits,
    maximumFractionDigits,
    ...rest
}) => {
    const project = useSelector((state: IState) => state.global.activeProject);

    if (!project) {
        return <Trans>Invalid currency</Trans>;
    }
    return (
        <CurrencyDisplay
            minimumFractionDigits={
                minimumFractionDigits ?? getMinimumProjectFractionDigits(project.decimalOption)
            }
            maximumFractionDigits={
                maximumFractionDigits ?? getMaximumFractionDigits(project.decimalOption)
            }
            currency={project.currencyCode}
            {...rest}
        />
    );
};

export default ProjectCurrencyDisplay;
